import React from "react";
import { Tooltip } from "@mui/material";
import { ReactComponent as AddIcon } from "../../assets/images/add-circle-line.svg";
import styles from "./AddButton.module.css";

interface AddButtonProps {
    onClick: () => void;
    tooltip: string;
    disabled?: boolean;
    label?: string;
    labeledClassName?: string;
}

const AddButton: React.FC<AddButtonProps> = ({ onClick, tooltip, disabled = false, label, labeledClassName }) => {
    if (label) {
        return (
            <button
                onClick={onClick}
                className={[
                    styles.labeled,
                    "add-button-labeled",
                    labeledClassName,
                    disabled ? `${styles.labeledDisabled} add-button-disabled` : "",
                ]
                    .filter(Boolean)
                    .join(" ")}
                type="button"
                disabled={disabled}
                title={tooltip}
            >
                <span className={`${styles.labeledIcon} add-button-labeled-icon`}>+</span>
                <span className={`${styles.labeledText} add-button-labeled-text`}>{label}</span>
            </button>
        );
    }

    return (
        <Tooltip title={tooltip} arrow>
            <button
                onClick={onClick}
                className={`${styles.round} add-button-round ${disabled ? "disabled add-button-disabled" : ""}`}
                type="button"
                disabled={disabled}
            >
                <AddIcon className="add-button-icon" />
            </button>
        </Tooltip>
    );
};

export default AddButton;
